import { ProgressBar } from '@fluentui/react-components'
import styles from './Status.module.css'

interface ProgressStatusProps {
  progress: number
  description?: string
}

export const ProgressStatus = ({
  progress,
  description,
}: ProgressStatusProps) => (
  <div className={styles.progressStatus}>
    <div className={styles.progressContainer}>
      <p>{description ? description : 'Laddas...'}</p>
      <p>{`${Math.round(progress * 100)} %`}</p>
    </div>

    <ProgressBar value={progress} thickness="medium" color="brand" />
  </div>
)
